import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
import {} from "./JobStateSummary";
import CollectionProgress from "./CollectionProgress.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CollectionDescription',
    props: {
        elementCount: { default: undefined },
        elementsDatatypes: { default: undefined },
        jobStateSummary: null,
        collectionType: null
    },
    setup(__props) {
        const props = __props;
        const labels = new Map([
            ["list", "list"],
            ["list:paired", "list"],
            ["list:list", "list"],
            ["paired", "pair"],
        ]);
        const collectionLabel = computed(() => {
            var _a;
            return (_a = labels.get(props.collectionType)) !== null && _a !== void 0 ? _a : "nested list";
        });
        const hasSingleElement = computed(() => {
            return props.elementCount === 1;
        });
        const isHomogeneous = computed(() => {
            var _a;
            return ((_a = props.elementsDatatypes) === null || _a === void 0 ? void 0 : _a.length) === 1;
        });
        const homogeneousDatatype = computed(() => {
            var _a;
            return isHomogeneous.value ? ` ${(_a = props.elementsDatatypes) === null || _a === void 0 ? void 0 : _a[0]}` : "";
        });
        const pluralizedItem = computed(() => {
            if (props.collectionType === "list:list") {
                return pluralize("list");
            }
            if (props.collectionType === "list:paired") {
                return pluralize("pair");
            }
            if (!labels.has(props.collectionType)) {
                return pluralize("dataset collection");
            }
            return pluralize("dataset");
        });
        function pluralize(word) {
            return hasSingleElement.value ? word : `${word}s`;
        }
        return { __sfc: true, props, labels, collectionLabel, hasSingleElement, isHomogeneous, homogeneousDatatype, pluralizedItem, pluralize, CollectionProgress };
    }
});
